import Main from "./pages/Main";
import Loading from "./pages/Loading";
import { useStoreRehydrated } from "easy-peasy";
export default function App() {
  const isRehydrated = useStoreRehydrated();
  return <div>{isRehydrated ? <Main /> : <Loading />}</div>;
}
